(function () {
  var box = document.createElement('div');
  var intervalId = null;

  box.className = 'jit-no-results';
  box.style.display = 'none';
  document.body.appendChild(box);

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function getVisibleSearchInput() {
    var inputs = document.querySelectorAll('.header-custom__search-input.field__input');

    for (var i = 0; i < inputs.length; i++) {
      if (isVisible(inputs[i])) return inputs[i];
    }

    return null;
  }

  function isSearchFocused() {
    var active = document.activeElement;
    return !!(active && active.matches('.header-custom__search-input.field__input'));
  }

  function positionBox(input) {
    if (!input) return;

    var rect = input.getBoundingClientRect();
    box.style.position = 'absolute';
    box.style.left = (window.scrollX + rect.left) + 'px';
    box.style.top = (window.scrollY + rect.bottom + 6) + 'px';
    box.style.width = Math.max(rect.width, 300) + 'px';
    box.style.zIndex = '999999';
  }

  function showBox(term, input) {
    box.innerHTML = `
      <div class="jit-no-results-inner">
        <div class="jit-no-results-text">
          No results for "<strong>${term}</strong>"
        </div>
        <a href="/pages/request-a-quote?query=${encodeURIComponent(term)}" class="jit-no-results-link" data-rfq-link="true">
          Request a quote
        </a>
      </div>
    `;

    positionBox(input);
    box.style.display = 'block';
  }

  function hideBox() {
    box.style.display = 'none';
  }

  function hasRealResults() {
    var resultsBox = document.querySelector('#cloud-search-results');
    if (!resultsBox) return false;

    var items = resultsBox.querySelectorAll('.cs-item');
    return items.length > 0;
  }

  function tick() {
    var input = getVisibleSearchInput();

    if (!input || !isSearchFocused()) {
      hideBox();
      return;
    }

    var term = (input.value || '').trim();
    if (term.length < 2) {
      hideBox();
      return;
    }

    if (hasRealResults()) {
      hideBox();
      return;
    }

    showBox(term, input);
  }

  function startLoop() {
    stopLoop();
    intervalId = setInterval(tick, 120);
  }

  function stopLoop() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  document.addEventListener('focusin', function (e) {
    if (!e.target.matches('.header-custom__search-input.field__input')) return;
    startLoop();
    tick();
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('.header-custom__search-input.field__input')) return;
    tick();
  });

  document.addEventListener('focusout', function (e) {
    if (!e.target.matches('.header-custom__search-input.field__input')) return;

    setTimeout(function () {
      if (!isSearchFocused()) {
        stopLoop();
        hideBox();
      }
    }, 150);
  });

  document.addEventListener('mousedown', function (e) {
    var link = e.target.closest('[data-rfq-link="true"]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();
    window.location.href = link.getAttribute('href');
  }, true);

  window.addEventListener('resize', function () {
    if (box.style.display === 'block') {
      var input = getVisibleSearchInput();
      if (input) positionBox(input);
    }
  });

  window.addEventListener('scroll', function () {
    if (box.style.display === 'block') {
      var input = getVisibleSearchInput();
      if (input) positionBox(input);
    }
  });
})();